import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

export async function get(path, opts) {
    const { data } = await api.get(path, opts);
    return data;
}

export async function post(path, body, opts) {
    const { data } = await api.post(path, body, opts);
    return data;
}

export async function patch(path, body, opts) {
    const { data } = await api.patch(path, body, opts);
    return data;
}
